export interface RRIMediaFile {
  filename: string;
  mimeType: string;
  downloadUrl: string;
}
